
import { Injectable } from '@angular/core';
import {
    HttpEvent, HttpRequest, HttpHandler,
    HttpInterceptor, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, TimeoutError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogModalComponent, IBasicModalComponentInstance, BasicModalOperationResult } from 'src/app/shared/components/dialog-modal/dialog-modal.component';
import { Router } from '@angular/router';
import { LoadingService } from '../services/loading.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {

    constructor(private modalService: NgbModal,
        private loadingService: LoadingService,
        private router: Router,
        private translateService: TranslateService) {

    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request).pipe(
            retry(0),
            catchError((ex: HttpErrorResponse) => {
                if (ex instanceof TimeoutError) {
                    this.modalService.dismissAll();
                    this.loadingService.stopAll();
                    this.showError("Ocurrió un error inesperado. Vuelva a intentar en unos minutos. Si el error persiste, póngase en contacto con la administración");
                    this.router.navigateByUrl("/");
                }
                if (ex.status == 400) {
                    if (Array.isArray(ex.error)) {
                        this.loadingService.stopAll();
                        let errorMessage: string = "";
                        for (let err in ex.error) {
                            if(ex.error[err].code && !isNaN(ex.error[err].code)){
                                errorMessage += this.translateService.instant("errorCode."+ex.error[err].code);
                                errorMessage += "\n\r";
                            }
                            else if (ex.error[err].description) {
                                errorMessage += this.translateService.instant(ex.error[err].description);
                                errorMessage += "\n\r";
                            }
                        }

                        if (ex.error.filter(x => x.description.includes('login')).length > 0) {
                            let type = BasicModalOperationResult.Error;
                            if(ex.error.filter(x => x.description.includes('login.loginRTUserToBeConfirmed')).length > 0) 
                                type = BasicModalOperationResult.Warning;
                            this.showErrorLogin(errorMessage, type);
                        } else {
                            this.showError(errorMessage);
                        }
                    }
                }
                else if (ex.status == 500) {
                    if (ex.error.message) {
                        this.showError(ex.error);
                    }
                }
                return throwError(ex);
            })
        );
    }

    showError(error: string) {
        const modalInstance = this.modalService.open(DialogModalComponent).componentInstance as IBasicModalComponentInstance;
        modalInstance.title = "Error";
        modalInstance.body = error;
        modalInstance.type = BasicModalOperationResult.Error;

        modalInstance.buttons = [{
            text: "Ok",
            cssClass: "btn btn-success",
            closeModalOnClick: true,
        }];
    }

    showErrorLogin(error: string, type: BasicModalOperationResult) {
        const modalInstance = this.modalService.open(DialogModalComponent).componentInstance as IBasicModalComponentInstance;
        modalInstance.title = "Error";
        //TODO: mejorar la logica
        if(type == BasicModalOperationResult.Warning)
            modalInstance.title = "Confirmación Pendiente";
        modalInstance.body = error;
        modalInstance.type = type;

        modalInstance.buttons = [{
            text: "Ok",
            cssClass: "btn btn-success",
            closeModalOnClick: true,
            handler: async (btn) => {
                this.router.navigateByUrl("/");
            },
        }];
    }
}